export const prefix = (name) => sessionStorage.getItem(`${name}Prefix`) || '';
export const suffix = (name) => sessionStorage.getItem(`${name}Suffix`) || '';
